import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles/global.css";

// No async bootstrap indirection here, unlike kwms-web -- that exists only
// to let Module Federation's shared-scope negotiation finish first, and
// this app doesn't use Module Federation (see rspack.config.ts).
const container = document.getElementById("root");
if (!container) {
  throw new Error("#root element not found");
}

createRoot(container).render(<App />);
